import {Injectable} from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AzureAuthService {
    dataSrc: number[] = Array.from(Array(1000).keys());

    private AUTH_ENDPOINT = environment.AUTH_ENDPOINT;
    private AUTH_CLIENT_ID = "apiclient";
    private AUTH_CLIENT_SECRET = "ip8YRYfG";
    private AUTH_SCOPE = "roles api.v1";
    private _authToken: any;


    constructor(
        //private authService: AppAuthService,
    ) {}

    setAuthToken(data){
        this._authToken = data;
    }

    clearAuthToken(){
        this._authToken = undefined;
    }

    getAuthToken(){
        return this._authToken;
    }
}
